
import { computed, defineComponent, PropType } from 'vue'
import {
  isNowBeforeTimeString,
  isNowAfterTimeString,
  isNowBetweenTwoTimeString,
} from '@/utils/eventDetailOnlineTableUtils'

export default defineComponent({
  name: 'EventDetailOnlineTableCellLabels',
  props: {
    currentDate: {
      type: String, // YYYY-M-D H:m
      default: ''
    },
    eventDate: {
      type: String, // YYYY-MM-DD HH:mm:ss
      default: ''
    },
    programLabels: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    programStartTime: {
      type: String, // HH:mm
      default: ''
    },
    ProgramEndTime: {
      type: String, // HH:mm
      default: ''
    }
  },
  setup(props) {
    const beforeProgramStart = computed(() => {
      return isNowBeforeTimeString(props.currentDate, props.eventDate)
    })
    const afterProgramEnd = computed(() => {
      return isNowAfterTimeString(props.currentDate, props.eventDate)
    })
    const nowOnAir = computed(() => {
      return isNowBetweenTwoTimeString(props.currentDate, props.eventDate)
    })
    return {
      beforeProgramStart,
      afterProgramEnd,
      nowOnAir
    }
  }
})
